import React from 'react'
import { useAddNewNoteMutation } from './notesApiSlice'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'


const NewNoteForm = ({users}) => {

    const navigate = useNavigate()
    const [addNewNote,{
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewNoteMutation()

    const [title, setTitle] = useState('')
    const [text, setText ] = useState('')
    const [userId, setUserId ] = useState('')

    useEffect(()=>{
        if(isSuccess){
            setTitle('')
            setText('')
            setUserId('')
            navigate('/dash')
        }
    },[navigate,isSuccess])

    const onTitleChanged = e => setTitle(e.target.value)
    const onTextChanged = e => setText(e.target.value)
    const onUserIdChanged = e => setUserId(e.target.value)

    const canSave = [userId, text, title].every(Boolean) && !isLoading

    const onSaveNoteClicked = async (e) => {
        e.preventDefault()
        if(canSave){
            await addNewNote({user: userId, title, text})
        }
    }

    const options = users.map(user => {
        return(
            <option key={user.id} value={user.id}>{user.username}</option>
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"
    const validTitleClass = !title ? "form__input--incomplete" : ''
    const validTextClass = !text ? "form__input--incomplete" : ''

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>
            <form className='form' onSubmit={onSaveNoteClicked}>
                <div className='form__title-row'>
                    <h2>New Note</h2>
                    <div className='form__action-buttons'>
                        <button
                            className='icon-button'
                            title='Save'
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave}/>
                        </button>
                    </div>
                </div>
                <label className='form__label' htmlFor='title'>Title: </label>
                <input 
                    className={`form__input ${validTitleClass}`}
                    id='title'
                    type='text'
                    value={title}
                    name='title'
                    autoComplete='off'
                    onChange={onTitleChanged}
                />
                <label className='form__label' htmlFor='text'>
                    Text: 
                </label>
                <textarea 
                    className={`form__input form__input--text ${validTextClass}`}
                    id='text'
                    name='text'
                    value={text}
                    onChange={onTextChanged}
                />
                <label className='form__label form__checkbox-container' htmlFor='username'>
                    ASSIGNED TO: 
                </label>
                    <select
                        className='form__select'
                        id='username'
                        name='username'
                        value={userId}
                        onChange={onUserIdChanged}
                    >
                        {options}
                    </select>
                
            </form>
        
        </>

    )
  return content
}

export default NewNoteForm